import type { FC } from 'react'

import styled from '@emotion/styled'

import { useTheme } from '@emotion/react'

import Typography from '@segment/matcha/components/Typography'

import ScoreMeter from '@segment/matcha/recipes/ScoreMeter'

interface ResultCardProps {
  score: number
  title: string
  rating: string
  summary: string
  list: string[]
}

const ResultCard: FC<ResultCardProps> = ({ score, title, rating, summary, list }) => {
  const theme = useTheme()

  return (
    <div>
      <ScoreMeter score={score} title={title} rating={rating} maxScore={3} />
      <Typography variant="pSmall" tokens={{ color: theme.palette.twilio.gray[100] }}>
        {summary}
      </Typography>
      <Typography variant="h5" tokens={{ color: theme.palette.twilio.gray[100] }}>
        Recommendations
      </Typography>
      <List>
        {list.map((item) => (
          <li key={item}>
            <StyledTypography variant="pSmall" tokens={{ color: theme.palette.twilio.gray[100] }}>
              {item}
            </StyledTypography>
          </li>
        ))}
      </List>
    </div>
  )
}

const List = styled.ul`
  padding-left: 30px;
`

const StyledTypography = styled(Typography)`
  margin: 10px 0;
`

export default ResultCard
